<template>
    <transition name="fade">
        <div
            class="vue-popup"
            v-if="modelValue"
            @mousedown.self="close"
        >
            <div class="vue-popup__container" :style="createStyle()">
                <span class="vue-popup__close" @click="close">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
                    <path fill="#888" d="M5.715 7.129l-4.297 4.293L0 10.004 4.297 5.71 0 1.42 1.418 0l4.297 4.297L10.012 0l1.41 1.422L7.129 5.71l4.293 4.293-1.41 1.418z"/>
                </svg>
                </span>

                <div class="vue-popup__content" ref="content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'vue-popup',
        selector: '.vue-popup',
        props: ['modelValue', 'styles'],
        methods: {
            createStyle() {
                let obj = {
                    maxWidth: `${ this.styles && this.styles.maxWidth ? this.styles.maxWidth : '1200px'}`,
                }
                if (this.styles !== undefined) {
                    obj = {
                        ...obj,
                        ...this.styles
                    }
                }
                return obj;
            },
            close() {
                this.$emit('update:modelValue', false);
            }
        }
    }
</script>

<style lang="scss">
    .vue-popup{
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .5);
        z-index: 2000;
        &__container{
            position: relative;
            background-color: #fff;
            width: 100%;
            overflow: hidden;
            max-height: 100%;
        }
        &__content{
            position: relative;
            max-height: 100vh;
            overflow-y: auto;
            padding: 10px 10px 0;
            @media (min-width: 768px) {
                padding: 20px;
            }
        }

        &__close{
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            right: 10px;
            top: 10px;
            z-index: 2;
            width: 25px;
            height: 25px;
            :hover{
                cursor: pointer;
            }
            svg{
              width: 12px;
              height: 12px;
                fill: grey;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }

    .catalog-top{
        .vue-popup__content{
            overflow-y: auto;
        }
    }

    .product-detail{
        .vue-popup__content{
            overflow-y: auto;
        }
    }
</style>